import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import userInfo from 'src/services/userInfo';
import useIsMountedRef from 'src/hooks/useIsMountedRef';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	img: {
		width: '100%'
	}
}))

function LogoCobranding({ size, ...props }) {
	const classes = useStyles();
	const isMountedRef = useIsMountedRef();
	const [logoCobranding, setLogoCobranding] = useState(null);
	const account = useSelector(state => state.account);

	const hasBpartner = !!account?.user?.extensions?.profiles?.some(p => p.bpartnerId);

	const getLogoCobranding = useCallback(() => {
		if (!props?.src && hasBpartner)
			userInfo.getLogoCobranding(size).then(r => {
				if (isMountedRef.current && r != null)
					setLogoCobranding(r);
			});
	}, [hasBpartner, isMountedRef])

	useEffect(() => {
		getLogoCobranding();
	}, [getLogoCobranding])

	if (!logoCobranding && !props?.src) return null;

	return (
		<img
			alt="Logo"
			src={logoCobranding}
			className={classes.img}
			{...props}
		/>
	);
}

export default LogoCobranding;
